import { openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/pickup-total-pickup.svg'


const _hoisted_1 = {
  src: _imports_0,
  width: "20",
  height: "20",
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("img", _hoisted_1))
}